import { SelectInput } from "react-admin";

const CASE_SCENARIO_CHOICES = ["case_scenario_1", "case_scenario_2"].map((id) => ({
  id,
  name: `resources.technical-reports.fields.case_scenario.${id}`,
}));

const CaseScenarioSelectInput = (props) => (
  <SelectInput {...props} choices={CASE_SCENARIO_CHOICES} style={{ minWidth: 250 }} />
);

export default CaseScenarioSelectInput;
